import React, { useState, useEffect, useMemo } from 'react';
import DeleteIcon from '@material-ui/icons/Delete'; // import a different icon from material-ui library
import CommonTable from '../../../components/common/common-table/common-table';
import MonitorProductColumnModel from './monitor-product-column-model'
import CommonDialog from '../../../components/common/others/common-dialog';
import ProductSelectPage from './product-select-page';
import { buildMonitorTableData } from './monitor-product-data';

import { getRandomKey } from '../../../services/lib/utils/helpers';
import { Tabs, Modal, Input, message } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import './tab.css';
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service';
import { ApiRequest } from '../../../services/api/api';
import { getUserId } from '../../../services/lib/utils/auth.utils';
import { useDocumentTitle } from '../../../services/title/useDocumentTitle';




const MonitorProductPage = (props: { }): any => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false);
  const [open, setOpen] = useState<any>(false);
  const [productType, setProductType] = useState<any>(null);
  const [typeArray, setTypeArray] = useState<any[]>([]); // State to hold the array of types
  const [monitorData, setMonitorData] = useState<any[]>([])
  // Inventory Planning Notes (description) 编辑对话框
  const [descEditing, setDescEditing] = useState<{ open: boolean, productId: number | null, value: string }>({
    open: false, productId: null, value: ''
  })
  const [descSaving, setDescSaving] = useState(false);

  // const typeArray = [
  //   { type: 1, color: 'white', name: "B/W Cups" }, // light red
  //   { type: 2, color: '#white', name: "Colour Cups" }, // light green
  //   { type: 3, color: '#white', name: "Custom Cups" }, // light blue
  //   { type: 4, color: '#white', name: "Other Cups" }, // light orange
  //   { type: 5, color: '#white', name: "GSP Paper" }, // light purple
  //   { type: 6, color: '#white', name: "Local Purchase" }, // light red
  //   { type: 7, color: '#white', name: "Biopak" }, // light green
  //   { type: 8, color: '#white', name: "Bonson" }, // light blue
  //   { type: 9, color: '#white', name: "Jane's Trading" }, // light orange
  //   { type: 10, color: '#white', name: "Fortune" }, // light purple
  //   // { type: 11, color: '#white', name: "Confoil / Pacific Carton" }, // light purple
  //   { type: 11, color: '#white', name: "J&H" }, // light purple
  //   { type: 12, color: '#white', name: "Offshore Purchase" }, // light purple
  //   { type: 13, color: '#white', name: "EcoH" }, // light purple
  //   { type: 14, color: '#white', name: "Eco-Forward" }, // light purple
  //   { type: 15, color: '#white', name: "Qian Lin" }, // light purple
  //   { type: 16, color: '#white', name: "Rong Feng" }, // light purple
  // ];    //MonitorProductGroup

  const [tabIndex, setTabIndex] = useState(1);
  const fetchTypes = async () => { ApiRequest({
    url: `/MonitorProductGroup/GetAllMonitorProductGroup`,
    method: 'get',
    // data: [{ productId: productId, type: 0 }] // Example of sending data in request body
  }).then(response => {
    // Handle success response (optional)
    let data = response.data.data;
    data = data.filter((typeObj: any) => typeObj.active);
    data = data.sort((a: any, b: any) => a.type - b.type);
    console.log('API call successful:', data);
    setTypeArray(data);
    setTabIndex(data[0].type);
  }).catch(error => {
    // Handle error (optional)
    console.error('API call failed:', error);
    // Implement error handling as per your application's requirements
  });
  };
  
  const handleTabChange = (key: any) => {
    setTabIndex(Number(key));
  };  
    useDocumentTitle();
  useEffect(() => {
    // document.title = "Inventory Monitoring";
    fetchTypes();
  }, []);
  // 注册全局打开 Inventory Planning Notes 的回调 (列点击时调用)
  useEffect(() => {
    ;(window as any).__openInventoryNotes = (rowData: any) =>
      openDescDialog(rowData.productId, rowData.description)
    return () => { delete (window as any).__openInventoryNotes }
  }, [])

  // The monitor API returns the full dataset regardless of tab, so fetch it
  // once and let tab switches re-filter on the client without more requests.
  // GetMonitor rows don't carry the product's planning description, so load it
  // from the product list and merge it into each row by productId.
  const fetchProductDescriptions = async () => {
    try {
      const response = await ApiRequest({
        url: 'Product/GetAllProduct?withOutStock=true',
        method: 'get',
        isShowSpinner: false
      })
      const descriptions: any = {}
      ;(response?.data?.data ?? []).forEach((product: any) => {
        if (product?.productId != null) {
          descriptions[product.productId] = product.description ?? ''
        }
      })
      return descriptions
    } catch (error) {
      console.error('Failed to load product descriptions', error)
      return {}
    }
  }

  const fetchMonitorData = () => {
    Promise.all([
      ApiRequest({
        url: 'StockMonitor/GetMonitor',
        method: 'get',
        isShowSpinner: true
      }).catch(error => {
        console.error('Failed to load monitor data', error)
        return null
      }),
      fetchProductDescriptions()
    ]).then(([monitorResponse, descriptions]) => {
      const rows = monitorResponse?.data?.data ?? []
      setMonitorData(
        rows.map((row: any) => ({
          ...row,
          description:
            row.description ?? row.product?.description ?? descriptions[row.productId] ?? ''
        }))
      )
    })
  };

  useEffect(() => {
    fetchMonitorData();
  }, [triggerResetData]);

  const tableData = useMemo(() => buildMonitorTableData(monitorData, tabIndex), [monitorData, tabIndex]);
  const columns = useMemo(() => MonitorProductColumnModel().filter((e: any) => e.field !== "isLowStock"), []);

  const handleClick = (event: any, rowData: any, typeObj: any) => {
    // Do something with the buttonType argument
    setProductType(typeObj)
    setOpen(true)
    // console.log(`Button ${buttonType} clicked`);
  };
  const onDialogClose = (isModified: boolean) => {
    setOpen(false)
    if (isModified) {
      setTriggerResetData(getRandomKey())
    }
  }
  const customTooltip =(typeObj:any)=>(
    // <div style={{  color: typeObj.color }}>
    <div>
      Product {typeObj.name} Setting
    </div>
  );


  // const actionButtons = typeArray.map((typeObj) => ({
  //   icon: 'ghost',
  //   tooltip:customTooltip(typeObj),
  //   isFreeAction: true,
  //   onClick: (event: any, rowData: any) => handleClick(event, rowData, typeObj),
  // }));

  const actionButtons2 = [
    {
      icon: 'ghost',
        tooltip:customTooltip("Product Setting"),
        isFreeAction: true,
        onClick: (event: any, rowData: any) => {
          // debugger
          console.log("Debugging onClick:", {
            event,
            rowData,
            typeObj: typeArray[tabIndex - 1],
            tabIndex,
            typeArray
          });
          let typeObj = typeArray.filter(item => item.type === tabIndex)[0];
          // handleClick(event, rowData, typeArray[tabIndex - 1]);
          handleClick(event, rowData, typeObj);
          ;
        }
    },
    {
      icon: 'ghost',
      tooltip: 'Change MSL',
      onClick: async (event:any, rowData:any) => {
        // Do save operation
        // const res = await SweetAlertService.inputConfirm ("You want to delete?")
        const res = await SweetAlertService.inputConfirm({
          type: 'number',
          title: 'Change MSL',
          textLabel: 'MSL: ',
          placeholder: 'Quantity',
          defaultValue: rowData.productInventoryInfo.productMsl
      });
      
        if (!res) return;

        let qty = parseInt(res);
        if (qty == rowData.productInventoryInfo.productMsl){
          await SweetAlertService.errorMessage ("New MSL  (Minimum Stock Level) must be different from the current one.");
          return
        }
        // [{"productId":78,"type":2},{"productId":79,"type":2}]
        // `https://example.com/api/changeMsl?productId=${productId}&employeeId=${employeeId}&msl=${msl}`;
        ApiRequest({
          url: `Product/ChangeMsl?productId=${rowData.productId}&employeeId=${getUserId()}&msl=${qty}`,
          method: 'PUT',
          // data: [{productId: rowData.productId, type:0}]
        }).then(_ => {
          // setTriggerResetData(!triggerResetData)
          setTriggerResetData(getRandomKey())
        })          
      }
    },    
    {
      icon: 'Danger',
      tooltip: 'Delete',
      onClick: async (event:any, rowData:any) => {
        // Do save operation
        const res = await SweetAlertService.confirmMessage("You want to delete?")
        if (!res) return;
        // [{"productId":78,"type":2},{"productId":79,"type":2}]
        ApiRequest({
          url: 'ProductType/AddMonitorProducts',
          method: 'POST',
          data: [{productId: rowData.productId, type:0}]
        }).then(_ => {
          // setTriggerResetData(!triggerResetData)
          setTriggerResetData(getRandomKey())
        })          
      }
    }
  ];
  // 打开 / 保存 Inventory Planning Notes (description)
  const openDescDialog = (productId: number, currentDesc: string) => {
    setDescEditing({ open: true, productId, value: currentDesc || '' })
  }
  const closeDescDialog = () => {
    setDescEditing({ open: false, productId: null, value: '' })
  }
  const saveDescription = async () => {
    const { productId, value } = descEditing
    if (productId == null) return
    setDescSaving(true)
    try {
      await ApiRequest({
        url: 'Product/UpdateDescription?productId=' + productId + '&description=' + encodeURIComponent(value),
        method: 'put',
      })
      // 本地更新该行, 避免重新拉取
      setMonitorData((prev) => prev.map((row: any) => row.productId === productId ? { ...row, description: value } : row))
      message.success('Inventory Planning Notes updated')
      closeDescDialog()
    } catch (e) {
      message.error('Failed to update Inventory Planning Notes')
    } finally {
      setDescSaving(false)
    }
  }

  const rowStyle = (rowData: any) => {
      // if (rowData.type) {
      //   return { backgroundColor: getTypeColor(rowData.type) };
      // } else {
      //   return {}; // return empty object for all other rows (no background color)
      // }
      const productInStock = rowData.productInStock ?? 0;
      const poQty = rowData.poQty ?? 0;
      const pendingWorkOrderQuantity = rowData.pendingWorkOrderQuantity ?? 0;
      const pendingOrder = rowData.pendingOrder ?? 0;
      const productMsl = rowData.productMsl;
      return {
        backgroundColor:
        productInStock + poQty + pendingWorkOrderQuantity - pendingOrder < productMsl
          ? '#FFEBEE' 
          : 'transparent',
      };
  };

  
  return (
    <div >
      <Tabs className="custom-tabs" activeKey={String(tabIndex)} onChange={handleTabChange}>
        {typeArray.map((typeObj) => {
          // 如果需要调试每个 typeObj，可以在这里打印
          // console.log("productType typeObj:", productType);
          return (
            <TabPane 
              tab={typeObj.type === 0 ? "Tab" : typeObj.name.toUpperCase()} 
              key={typeObj.type}
            />
          );
        })}
      </Tabs>
      <CommonTable
        title='Inventory Monitoring'
        column={columns}
        initData={tableData}
        actionButtons={actionButtons2}
        columnsButton={true}
        isNotAddable={true}
        isNotDeletable={true}
        isNotEditable={true}
        rowStyle={rowStyle}
      />
      <CommonDialog
        title={'Choose products'}
        open={open}
        onDialogClose={onDialogClose}
        dialogContent={<ProductSelectPage onDialogClose={onDialogClose} typeObj={productType} typeArray={typeArray}/>}
      />
      <Modal
        title="Inventory Planning Notes"
        visible={descEditing.open}
        onOk={saveDescription}
        onCancel={closeDescDialog}
        confirmLoading={descSaving}
        okText="Save"
        cancelText="Cancel"
        maskClosable={false}
      >
        <Input.TextArea
          rows={4}
          value={descEditing.value}
          onChange={(e: any) =>
            setDescEditing((prev) => ({ ...prev, value: e.target.value }))
          }
          placeholder="Enter inventory planning notes"
          maxLength={500}
        />
      </Modal>
    </div>
  );
};

export default MonitorProductPage;
